import { actionTypes } from "./projectActionTypes";

const normalize = (row) => {
  if (!row || typeof row !== "object") return row;
  return {
    ...row,
    id: row.id ?? row.Id,
    name: row.name ?? row.Name,
    notes: row.notes ?? row.Notes,
    isActive: row.isActive !== undefined ? row.isActive : row.IsActive,
    createdDate: row.createdDate ?? row.CreatedDate,
    userCount: (() => {
      const c =
        row.userCount ??
        row.UserCount ??
        row.associatedEmployeeCount ??
        row.AssociatedEmployeeCount;
      if (c === undefined || c === null) return undefined;
      return Number(c);
    })(),
  };
};

const INITIAL_STATE = {
  record: [],
  isLoading: false,
  isLoadingMore: false,
  Error: false,
  message: "",
};

export default function projectReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case actionTypes.PR_LOADING_START:
      return { ...state, isLoading: true, isLoadingMore: false, message: "" };
    case actionTypes.PR_LOADING_STOP:
      return { ...state, isLoading: false, message: "" };
    case actionTypes.PR_LOADING_MORE_START:
      return { ...state, isLoadingMore: true, message: "" };
    case actionTypes.PR_LOADING_MORE_STOP:
      return { ...state, isLoadingMore: false };
    case actionTypes.PR_SHOW_LIST:
      return {
        ...state,
        Error: false,
        record: Array.isArray(action.payload)
          ? action.payload.map(normalize)
          : [],
        isLoading: false,
        isLoadingMore: false,
      };
    case actionTypes.PR_APPEND_LIST: {
      const incoming = Array.isArray(action.payload)
        ? action.payload.map(normalize)
        : [];
      const seen = new Set(state.record.map((r) => r.id));
      const merged = [...state.record];
      incoming.forEach((r) => {
        if (r.id == null || seen.has(r.id)) return;
        seen.add(r.id);
        merged.push(r);
      });
      return {
        ...state,
        Error: false,
        record: merged,
        isLoading: false,
        isLoadingMore: false,
      };
    }
    case actionTypes.PR_ADD_SUCCESS: {
      const row = normalize(action.payload);
      return {
        ...state,
        Error: false,
        isLoading: false,
        record: [...state.record, row],
      };
    }
    case actionTypes.PR_UPDATE_SUCCESS: {
      const row = normalize(action.payload);
      const id = row.id;
      return {
        ...state,
        Error: false,
        isLoading: false,
        record: state.record.map((r) =>
          r.id === id ? { ...r, ...row } : r
        ),
      };
    }
    case actionTypes.PR_DELETE_SOFT: {
      const target = action.payload;
      const id = target.id ?? target.Id;
      return {
        ...state,
        Error: false,
        isLoading: false,
        record: state.record.map((r) =>
          r.id === id ? { ...r, isActive: false } : r
        ),
      };
    }
    default:
      return state;
  }
}
